export default __webpack_public_path__ + "static/internation-patent-996c922de86c01cce5ecabbe5dbf2550.webp";